<div class="container-fuild p-4">

  <h4 class="d-flex align-items-center justify-content-between">
    <span>Últimos sobres completados</span>
  </h4>

  <form [formGroup]="formSearch">
    <div class="row align-items-center">
      <div class="col-md-6 col-sm-12">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Buscar por: título" aria-label="Búsqueda por título"
            aria-describedby="btn-search" formControlName="search" />
          <button class="input-group-text" id="btn-search" type="submit" style="cursor: pointer;" [disabled]="spinner"
            (click)="clickSearch()">
            <i class="fa fa-search" *ngIf="!spinner"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="spinner"></span>
          </button>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 text-md-end text-start mb-3 mb-md-0">
        
      </div>
    </div>
  </form>

  <app-paginacion [currentPage]="currentPage" [totalItems]="totalItems" [selectedPageSize]="pageSize"
    [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
    (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [loading]="spinner">
  </app-paginacion>
</div>

<ng-template #modalDescargaDocumento let-modal>
  <div class="modal-header border-0 pb-0">
    <div>
      <h4 class="modal-title mb-0">Descargar documento</h4>
      <small class="text-muted">Previsualiza y descarga tu archivo:</small>

      <div class="download-filename">
        {{ loteSelected.titulo }}
      </div>
    </div>


    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body pt-2">
    <div class="download-modal">

      <div class="download-icon  text-center">
        <i class="fa fa-download" style="font-size: 4em;"></i>
      </div>
    </div>
  </div>

  <div class="modal-footer border-0 pt-2">
    <button type="button" class="btn btn-outline-secondary w-100" (click)="modal.close('Cerrar click')">
      Cerrar
    </button>
  </div>
</ng-template>